<template>
  <div>
    <az-back-button :route="{name: 'licitacao', params: {id: licitacaoId}, query: {edicao: true}}" text="Voltar para a licitação"></az-back-button>
    <br>
    <filtros-documentos :lotesDisponiveis="lotesDisponiveisFiltro"
                        :fornecedoresDisponiveis="fornecedoresDisponiveisFiltro"
                        @pesquisar="buscarPorFiltrosDocumentosVirtualizados"
                        ref="filtrosDocumentos"/>
    <v-divider/>
    <v-layout d-flex wrap align-center class="ml-2 pt-1 pb-1 justify-start acoes-em-massa">
      <v-flex xs12 sm12 md6 d-flex>
        <v-btn @click="abrirModalConfirmarAssinar(true)" style="text-align: center">
          <icone-assinar-documento class="mr-1"/>
          Assinar Selecionados
        </v-btn>
        <v-btn @click="abrirModalConfirmarJuntarEmMassa" style="text-align: center">
          <icone-juntar-documento class="mr-1"/>
          Juntar Selecionados
        </v-btn>
        <v-btn @click="abrirModalBaixarDocumentosSelecionados" style="text-align: center">
          <v-icon class="mr-1">cloud_download</v-icon>
          Baixar Selecionados
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout v-if="exibirMensagemErroJuntar" class="mx-4 my-2 mensagem-erro-juntar error">
      <v-flex>
      <span class="mx-2" style="font-weight: bold">
        Ocorreu um erro ao juntar. Os seguintes documentos não puderam ser juntados ao processo digital:
      </span>
        <div class="mt-2">
          <v-chip v-for="doc in documentosNaoJuntados" :key="doc.id" class="chip-documento-erro" small @click="destacarDocTabela(doc)" text-color="black">
            {{doc.nome}}
            <v-tooltip content-class="tooltip-erro-documento" :disabled="!doc.erro" top>
              <v-icon class="ml-1" slot="activator" style="color: darkorange">warning</v-icon>
              Motivo: {{doc.erro}}
            </v-tooltip>
          </v-chip>
        </div>
      </v-flex>
      <v-icon @click="exibirMensagemErroJuntar = false" class="icone-fechar-mensagem-erro">close</v-icon>
    </v-layout>
    <v-divider/>
    <painel-documentos-tabela style="padding-bottom: 100px" :documentos="documentosVirtualizados" ref="tabelaDocumentos"
                              :total-itens="totalItens"
                              :paginacao="documentosVirtualizadosPaginacao.paginacao"
                              @paginar="eventoPaginar"
                              @baixar="abrirModalBaixarDocumento"
                              @assinar="abrirModalConfirmarAssinar(false, ...arguments)"
                              @juntar="abrirModalConfirmarJuntar"
                              @desentranhar="desentranharDocumento"
                              @reordenar="abrirModalreordenarDocumento"
                              @cancelar="abrirModalConfirmarCancelamento"
    />
    <modal-confirmar-cancelar-documento :mostrarDialogoCancelarDocumento="exibirModalConfirmarCancelamento"
                                        @fechar="exibirModalConfirmarCancelamento = false"
                                        @confirmar="cancelarDocumento(documentoManejando, ...arguments)"
    />
    <modal-confirmar-juntar-documento :mostrarDialogoJuntarDocumento="exibirModalConfirmarJuntar"
                                      :multiplo="manejandoMultiplos"
                                      @fechar="exibirModalConfirmarJuntar = false"
                                      @confirmar="juntarDocumento(documentoManejando)"
    />
    <modal-confirmar-assinar-documento :mostrarDialogoAssinarDocumento="exibirModalConfirmarAssinar"
                                       :multiplo="manejandoMultiplos"
                                       @fechar="exibirModalConfirmarAssinar = false"
                                       @confirmar="selecionarMetodoAssinar(documentoManejando, manejandoMultiplos)"
    />
    <modal-confirmar-baixar-documento :mostrarDialogoBaixarDocumento="exibirModalConfirmarBaixar"
                                      :multiplo="manejandoMultiplosBaixar"
                                      @fechar="exibirModalConfirmarBaixar = false"
                                      @confirmar="baixarDocumento(documentoManejando, ...arguments)"
    />

    <modal-reordenar-documento v-if="exibirModalReordenar"
                               :documentoReordenar="documentoManejando"
                               :documentosJuntados="documentosJuntados"
                               @fechar="exibirModalReordenar = false"
                               @confirmar="reordenarDocumento(documentoManejando, ...arguments)"
    />

    <ordenar-documentos-juntar v-if="exibirModalConfirmarJuntarEmMassa"
                               :documentosOrdenar="documentosParaJuntarEmMassa"
                               @fechar="exibirModalConfirmarJuntarEmMassa = false"
                               @confirmar="juntarEmLote"
    />

    <modal-reordenar-documento v-if="exibirModalReordenar"
                               :documentoReordenar="documentoManejando"
                               :documentosJuntados="documentosJuntados"
                               @fechar="exibirModalReordenar = false"
                               @confirmar="reordenarDocumento(documentoManejando, ...arguments)"
    />

    <ordenar-documentos-juntar v-if="exibirModalConfirmarJuntarEmMassa"
                        :documentosOrdenar="documentosParaJuntarEmMassa"
                        @fechar="exibirModalConfirmarJuntarEmMassa = false"
                        @confirmar="juntarEmLote"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import PainelDocumentosTabela from "@/views/licitacao/detalhe/orgao/documentosvirtualizacao/PainelDocumentosTabela";
import FiltrosDocumentos from "@/views/licitacao/detalhe/orgao/documentosvirtualizacao/FiltrosDocumentos";
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento";
import IconeJuntarDocumento from "@/commons/components/icones/IconeJuntarDocumento";
import ModalConfirmarCancelarDocumento from "@/commons/components/ModalConfirmarCancelarDocumento";
import ModalConfirmarJuntarDocumento from "@/commons/components/ModalConfirmarJuntarDocumento";
import ModalConfirmarAssinarDocumento from "@/commons/components/ModalConfirmarAssinarDocumento";
import ModalConfirmarBaixarDocumento from "@/commons/components/ModalConfirmarBaixarDocumento";
import ModalReordenarDocumento from "@/commons/components/ModalReordenarDocumento";
import OrdenarDocumentosJuntar from "@/views/licitacao/detalhe/orgao/components/OrdenarDocumentosJuntar";

export default {
  name: 'documentosVirtualizacao',
  components: {
    OrdenarDocumentosJuntar,
    ModalReordenarDocumento,
    ModalConfirmarBaixarDocumento,
    ModalConfirmarAssinarDocumento,
    ModalConfirmarJuntarDocumento,
    ModalConfirmarCancelarDocumento,
    IconeJuntarDocumento,
    IconeAssinarDocumento,
    FiltrosDocumentos,
    PainelDocumentosTabela,
  },
  data() {
    return {
      licitacaoId: null,
      lotesDisponiveisFiltro: [],
      fornecedoresDisponiveisFiltro: [],
      documentosNaoJuntados: null,
      exibirMensagemErroJuntar: false,
      documentoManejando: null,
      manejandoMultiplos: null,
      exibirModalConfirmarCancelamento: false,
      exibirModalConfirmarJuntar: false,
      exibirModalConfirmarJuntarEmMassa: false,
      documentosParaJuntarEmMassa: [],
      exibirModalConfirmarAssinar: false,
      exibirModalConfirmarBaixar: false,
      exibirModalReordenar: false,
      documentosJuntados : [],
      paginas: 0,
      totalItens: 0,
      manejandoMultiplosBaixar: false,
    }
  },
  computed: {
    ...mapState(['licitacao', 'lotesLicitacao', 'documentosVirtualizados', "documentosVirtualizadosPaginacao"])
  },
  async mounted() {
    try {
      this.setLicitacaoId()
      this.carregarFiltrosRouter()
      await this.buscarLotesLicitacao()
    } catch (e) {
      this.mostrarNotificacaoErro(e.message)
    }
  },
  methods: {
    destacarDocTabela(doc){
      const elementoDocumento = document.getElementById(doc.documentoVirtualizadoId)
      elementoDocumento.scrollIntoView({block: 'start', behavior:'smooth'});
      if(!elementoDocumento.classList.contains('transicionar-destacado')) {
        elementoDocumento.classList.add('transicionar-destacado');
        setTimeout(() => {
          elementoDocumento.classList.remove('transicionar-destacado');
        }, 1000)
      }
    },
    async buscarLotesLicitacao(){
      await this.$store.dispatch(actionTypes.BUSCAR_LOTES_ITEM_POR_LICITACAO, this.licitacaoId)
      this.lotesDisponiveisFiltro = this.lotesLicitacao.map(loteItem => {
        return {
          descricao: loteItem.licitacaoLote.lote.descricao,
          id: loteItem.licitacaoLote.lote.id,
        }
      })
    },
    async buscarDocumentosVirtualizados(){
      this.$store.commit(mutationTypes.SET_DOCUMENTOS_VIRTUALIZADOS, [])
      const filtros = this.$refs.filtrosDocumentos.filtros
      this.habilitarLoadingGlobal()

      const data = await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_LICITACAO,
          {
            licitacaoId: this.licitacaoId,
            paginacao: this.documentosVirtualizadosPaginacao.paginacao,
            filtros: filtros
          }
      )

      const {fornecedoresDisponiveis, paginacaoDocumentos} = data

      this.$store.commit(mutationTypes.SET_DOCUMENTOS_VIRTUALIZADOS, paginacaoDocumentos.items)
      this.paginas = paginacaoDocumentos.totalPages
      this.totalItens = paginacaoDocumentos.totalElements

      this.fornecedoresDisponiveisFiltro = fornecedoresDisponiveis
      this.desabilitarLoadingGlobal()
    },
    async selecionarMetodoAssinar(doc, multiplos){
      this.exibirModalConfirmarAssinar = false
      if(multiplos){
        await this.assinarEmLote();
      }else{
        await this.assinarDocumento(doc.uri)
      }
      this.manejandoMultiplos = false
      this.documentoManejando = null
    },
    async juntarDocumento(doc){
      this.exibirModalConfirmarJuntar = false
      const payload = {
        documentoId: doc.documentoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        tipoDocumento: doc.tipo,
        licitacaoId: this.licitacaoId
      }
      const resp = await this.$store.dispatch(actionTypes.FLOWBEE.JUNTAR_DOCUMENTO, payload)
      if(resp.juntadoComSucesso === true){
        this.mostrarNotificacaoSucesso('Documento juntado com sucesso!')
        doc.situacaoDocumento = 'JUNTADO'
        doc.juntado = true
        await this.buscarDocumentosVirtualizados()
      }else{
        throw new Error('Ocorreu um erro ao juntar o documento.')
      }
    },
    assinarDocumento(url){
      window.open(url, '_blank').focus();
    },
    async assinarEmLote(){
      const documentos = this.documentosVirtualizados.filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => !doc.juntado && !doc.cancelado)
      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.ASSINAR_EM_LOTE,
          {
            licitacaoId: this.licitacaoId,
            documentosIds: documentos.map(documento => documento.documentoVirtualizadoId)
          })
      if (resultado.sucesso) {
        this.mostrarNotificacaoSucesso("Documentos assinados com sucesso!")
      } else {
        this.mostrarNotificacaoErro("Não foi possível assinar!")
      }
    },
    async juntarEmLote(documentosJuntar){
      this.exibirModalConfirmarJuntarEmMassa = false
      if(documentosJuntar.length === 1){
        await this.juntarDocumento(documentosJuntar[0])
        return;
      }
      const requestObj = {
        licitacaoId: this.licitacaoId,
        documentos: documentosJuntar.map(doc => {
          return {
            documentoId: doc.documentoId,
            documentoVirtualizadoId: doc.documentoVirtualizadoId,
            tipoDocumento: doc.tipo
          }
        })
      }
      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.JUNTAR_EM_LOTE, requestObj)

      this.documentosNaoJuntados = resultado.documentosNaoJuntados.map(naoJuntadoApi => {
            const documentoNaoJuntado = this.documentosVirtualizados.find(
                doc => doc.documentoVirtualizadoId === naoJuntadoApi.documentoVirtualizadoId
            )
            documentoNaoJuntado.erro = naoJuntadoApi.erro
            return documentoNaoJuntado
          }
      )
      const idsNaoJuntados = resultado.documentosNaoJuntados.map(doc => doc.documentoVirtualizadoId)
      this.documentosVirtualizados.forEach(doc => {
        const documentoVirtualizadoId = doc.documentoVirtualizadoId
        if(this.$refs.tabelaDocumentos.selecionados.includes(documentoVirtualizadoId) && !idsNaoJuntados.includes(documentoVirtualizadoId)){
          doc.situacaoDocumento = 'JUNTADO'
          doc.juntado = true
        }
      })
      if(resultado.documentosNaoJuntados.length > 0) {
        this.exibirMensagemErroJuntar = true
      }else{
        this.mostrarNotificacaoSucesso("Documentos reordenados e juntados com sucesso!")
        this.exibirMensagemErroJuntar = false
      }
    },
    async baixarDocumento(doc, tipoDownload) {
      if (this.manejandoMultiplosBaixar) {
        await this.baixarDocumentosSelecionados(doc.documentosSelecionados, tipoDownload)
      } else {
        const payload = {
          licitacaoId: this.licitacaoId,
          documentoVirtualizadoId: doc.documentoVirtualizadoId,
          nomeArquivo: doc.nome,
          opcaoDownloadVirtualizacao: tipoDownload
        }
        await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_DOCUMENTO, payload)
      }

      this.exibirModalConfirmarBaixar = false
      this.manejandoMultiplosBaixar = false
    },
    async reordenarDocumento(doc, posicao) {
      this.exibirModalReordenar = false
      const payload = {
        licitacaoId: this.licitacaoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        novoNumeroSequencial: posicao
      }
      await this.$store.dispatch(actionTypes.FLOWBEE.REORDENAR_DOCUMENTO, payload)
      await this.buscarDocumentosVirtualizados()
      this.mostrarNotificacaoSucesso("Documento reordenado com sucesso!")
    },
    desentranharDocumento(doc) {
      if (doc.ehArquivoExterno) {
        alert('Não é possível desentranhar um arquivo externo. Execute a ação no sistema de origem.')
        return
      }

      this.$router.push({
        name: 'desentranhamento',
        params: {
          id: this.licitacaoId,
          documentoVirtualizadoId: doc.documentoVirtualizadoId
        }
      })
    },
    async abrirModalreordenarDocumento(doc){
      const data = await this.$store.dispatch(actionTypes.FLOWBEE.BUSCAR_TODOS_DOC_JUNTADO_PROCESSO, this.licitacaoId)
      this.documentosJuntados = data.documentosVirtualizados

      if(this.documentosJuntados.length === 1){
        this.mostrarNotificacaoErro("Não é possível reordenar. Só existe um documento juntado.")
        return
      }
      this.documentoManejando = doc
      this.exibirModalReordenar = true
    },
    abrirModalConfirmarCancelamento(doc){
      this.documentoManejando = doc
      this.exibirModalConfirmarCancelamento = true
    },
    abrirModalBaixarDocumento(doc) {
      this.documentoManejando = doc
      this.manejandoMultiplosBaixar = false
      this.exibirModalConfirmarBaixar = true
    },
    abrirModalConfirmarAssinar(multiplo, doc){
      const nomeUsuarioLogado = this.$store.state.loki.user.fullName.toUpperCase()
      if(multiplo) {
        if(this.$refs.tabelaDocumentos.selecionados.length === 0){
          this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para assinar.")
          return
        }
        const documentos = this.documentosVirtualizados.filter(documento => {
          return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
        })
        if(documentos.every(doc => doc.juntado || doc.cancelado)){
          this.mostrarNotificacaoErro("Não é possível assinar. Todos os documentos selecionados estão juntados ou cancelados.")
          return
        }
        const documentosAssinados = documentos.filter(doc =>
                doc.assinaturas && doc.assinaturas.some(assinatura =>
                    (assinatura.nomeSignatario || '').toUpperCase() === nomeUsuarioLogado
                )
        );
        if (documentosAssinados.length > 0) {
          const nomes = documentosAssinados.map(doc => doc.nome).join(', ');
          this.mostrarNotificacaoErro(
              `Não é possível assinar. Você já assinou os seguintes documentos: ${nomes}.`
          );
          return;
        }
      }

      if (!multiplo && doc.assinaturas && doc.assinaturas.some(assinatura => (assinatura.nomeSignatario || '').toUpperCase() === nomeUsuarioLogado)){
        this.mostrarNotificacaoErro("Não é possível assinar. Você já assinou este documento.")
        return
      }


      this.documentoManejando = doc
      this.manejandoMultiplos = multiplo
      this.exibirModalConfirmarAssinar = true
    },
    abrirModalConfirmarJuntar(doc){
      this.documentoManejando = doc
      this.exibirModalConfirmarJuntar = true
    },
    abrirModalConfirmarJuntarEmMassa(){
      if(this.$refs.tabelaDocumentos.selecionados < 1){
        this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para juntar!")
        return;
      }
      const documentosSelecionados = this.documentosVirtualizados.filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => !doc.juntado)
      if(documentosSelecionados.length < 1){
        this.mostrarNotificacaoErro("Todos os documentos selecionados já foram juntados!")
        return;
      }
      this.exibirModalConfirmarJuntarEmMassa = true
      this.documentosParaJuntarEmMassa = documentosSelecionados
    },
    async cancelarDocumento(doc, motivo){
      this.exibirModalConfirmarCancelamento = false
      const payload = {
        licitacaoId: this.licitacaoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        tipoDocumento: doc.tipo,
        motivoCancelamento: motivo
      }
      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.CANCELAR_DOCUMENTO, payload)
      if(resultado.canceladoComSucesso) {
        this.mostrarNotificacaoSucesso("Documento cancelado com sucesso!")
        doc.situacaoDocumento = 'CANCELADO'
        doc.cancelado = true
      }
    },
    setLicitacaoId() {
      this.licitacaoId = this.$route.params.id
    },
    carregarFiltrosRouter(){
      if(this.$route.params.filtros){
        if(this.$route.params.filtros.situacao) {
          this.$refs.filtrosDocumentos.filtros.situacao = this.$route.params.filtros.situacao
        }
      }
    },
    eventoPaginar(paginacao) {
      this.$store.commit(mutationTypes.SET_PAGINACAO_DOCUMENTOS_VIRTUALIZADOS, paginacao)
      this.buscarDocumentosVirtualizados()
    },
    buscarPorFiltrosDocumentosVirtualizados() {
      if (this.documentosVirtualizadosPaginacao.paginacao.page > 1) {
        this.$store.commit(mutationTypes.RESETAR_PAGINA_DOCUMENTOS_VIRTUALIZADOS)
        return
      }
      this.buscarDocumentosVirtualizados()
    },
    abrirModalBaixarDocumentosSelecionados() {
      if(this.$refs.tabelaDocumentos.selecionados.length === 0) {
        this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para baixar.")
        return
      }

      const documentosSelecionados = this.documentosVirtualizados.filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => !doc.cancelado)

      if(documentosSelecionados.length === 0) {
        this.mostrarNotificacaoErro("Nenhum documento válido selecionado para download.")
        return
      }

      if(documentosSelecionados.length === 1) {
        const doc = documentosSelecionados[0]
        this.abrirModalBaixarDocumento(doc)
        return
      }

      this.documentoManejando = {
        documentosSelecionados: documentosSelecionados,
        nome: `${documentosSelecionados.length} documento(s) selecionado(s)`
      }
      this.manejandoMultiplosBaixar = true
      this.exibirModalConfirmarBaixar = true
    },
    async baixarDocumentosSelecionados(documentosSelecionados, tipoDownload) {
      try {
        this.habilitarLoadingGlobal()

        const payload = {
          licitacaoId: this.licitacaoId,
          documentos: documentosSelecionados.map(doc => ({
            documentoVirtualizadoId: doc.documentoVirtualizadoId,
            nomeArquivo: doc.nome
          })),
          opcaoDownloadVirtualizacao: tipoDownload
        }
        await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_DOCUMENTOS_SELECIONADOS, payload)
        this.mostrarNotificacaoSucesso("Download iniciado com sucesso!")

      } catch (error) {
        this.mostrarNotificacaoErro("Erro ao baixar documentos selecionados: " + error.message)
      } finally {
        this.desabilitarLoadingGlobal()
      }
    },

  }
}
</script>
<style lang="stylus">
.icone-fechar-mensagem-erro
  color white !important
  height 24px

.mensagem-erro-juntar
  margin-top 5px
  border 4px solid red
  border-radius 10px
  color: white

.chip-documento-erro
  background-color: white !important
.chip-documento-erro:after
  color: white

html
  scroll-behavior smooth

.tooltip-erro-documento
  opacity: 1 !important
</style>
